export default () => ({
  dialogCloseButton: {
    float: 'right',
  },
  dialogActions: {
    padding: '8px 24px 16px 24px',
  },
  dialogButton: {
    width: '100%',
  },
})
